export const ADMIN_DETAILS_RECEIVED = 'ADMIN_DETAILS_RECEIVED'
export const ADMIN_DETAILS_UNLOADED = 'ADMIN_DETAILS_UNLOADED'
